<HomeNavBar v-if="!isHomePage"/>
<div v-if= 'client_features.show_ads && token_exists' class="position-relative advert ">
  <!-- Sponsored Ads Section -->
  <div
    class="position-absolute bottom-0 start-0 end-0 mx-2 sponsored-ads-container"
  >
    <div class="sponsored-header">
      Sponsored
    </div>
    <div class="ad-container">
      <div
        v-for="(ad, i) in filtered_ads"
        :key="i"
        class="ad-item"
        @click="openAd(ad)"
      >
        <div class="ad-content">
          <div class="ad-image">
            <img :src="ad.image" :alt="ad.title" class="ad-img" />
          </div>
    
          <div class="ad-details">
            <div class="ad-title">{{ ad.title }}</div>
    
            <!-- If download_links exist, show icons -->
            <div v-if="ad.download_links" class="download-icons d-flex gap-2" @click.stop>
              <a v-if="userPlatform === 'apple'" :href="ad.download_links.apple" target="_blank">
                <img src="@/assets/icons/app-store-apple-logo.svg" alt="Apple Store" class="icon" />
              </a>
              <a v-if="userPlatform === 'google'" :href="ad.download_links.google" target="_blank">
                <img src="@/assets/icons/google-play-logo.svg" alt="Google Play" class="icon" />
              </a>
              <a v-if="userPlatform === 'huawei'" :href="ad.download_links.huawei" target="_blank">
                <img src="@/assets/icons/huawei-appgallery-logo.png" alt="AppGallery" class="icon" />
              </a>
            </div>
    
            <!-- Otherwise, show old URL -->
            <div v-else class="ad-url">{{ ad.url }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<StickyNav v-if="!isHomePage" />